import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import {
  StyledTableCell,
  StyledTableRow,
  StyledTableHeaderRow,
} from '../style';

const GridLoader = ({ pageSize = 5, columns: columnsLength = 0 }) => {
  if (pageSize === 0) {
    pageSize = 10;
  }

  const columns = new Array(columnsLength).fill('Loading');
  const rows = new Array(pageSize).fill('Rows Loading');
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <StyledTableHeaderRow key={`loader-head-row`}>
            {columns.map((column, columnIndex) => {
              return (
                <StyledTableCell
                  className='loading'
                  key={`loader-head-col-${columnIndex}`}
                >
                  <span className='v-hidden'>{column}</span>
                </StyledTableCell>
              );
            })}
          </StyledTableHeaderRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => {
            return (
              <StyledTableRow key={`loader-row-${rowIndex}`}>
                {columns.map((column, columnIndex) => {
                  return (
                    <StyledTableCell
                      className='no-border'
                      key={`loader-row-${rowIndex}-col-${columnIndex}`}
                    >
                      <div
                        className='loading'
                        style={{
                          width:
                            rowIndex % 2 === 0
                              ? '100px'
                              : columnIndex % 2 === 0
                              ? '50px'
                              : 'auto',
                        }}
                      >
                        <span className='v-hidden'>{column}</span>
                      </div>
                    </StyledTableCell>
                  );
                })}
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GridLoader;
